
<template>

  <div class="page" id="sendmail">
    이메일전송
  </div>
</template>
<script>

import Vue from "vue";

export default {
  data(){
    return {
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>
